import { styled, useTheme } from '@mui/material/styles';

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open, user }) => ({
    ...(user?.userType === 'admin' ? theme.typography.adminMainContent : theme.typography.mainContent),
}));

const Layout = ({children}) => {
  const theme = useTheme();

  return (
    <Main theme={theme}>
      {children}
    </Main>
  );
};

export default Layout;
